import { createSlice } from "@reduxjs/toolkit";

export const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartItems: [],
    shippingAddress: {},
    paymentMethod: "",
  },
  reducers: {
    addItem: (state, action) => {
      const item = action.payload;
      const existItem = state.cartItems.find(
        (x) => x.product === item.product && x.selectedColor === item.selectedColor
      );
      if (existItem) {
        state.cartItems = state.cartItems.map((x) =>
          x.product === item.product && x.selectedColor === item.selectedColor
            ? { ...x, qty: x.qty + item.qty }
            : x
        );
      } else {
        state.cartItems.push({
          product: item.product,
          name: item.name,
          image: item.image,
          price: item.price,
          countInStock: item.countInStock,
          qty: item.qty,
          selectedColor: item.selectedColor || null,
          selectedColorName: item.selectedColorName || null,
        });
      }
      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },
    increaseQty: (state, action) => {
      const { product, selectedColor } = action.payload;
      const item = state.cartItems.find(
        (x) => x.product === product && x.selectedColor === selectedColor
      );
      if (item) {
        item.qty++;
        localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
      }
    },
    decreaseQty: (state, action) => {
      const { product, selectedColor } = action.payload;
      const item = state.cartItems.find(
        (x) => x.product === product && x.selectedColor === selectedColor
      );
      if (item && item.qty > 1) {
        item.qty--;
        localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
      }
    },
    removeItem: (state, action) => {
      const { product, selectedColor } = action.payload;
      state.cartItems = state.cartItems.filter(
        (x) => !(x.product === product && x.selectedColor === selectedColor)
      );
      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },
    clearItems: (state) => {
      state.cartItems = [];
      localStorage.removeItem("cartItems");
    },
    saveShippingAddress: (state, action) => {
      state.shippingAddress = action.payload;
      localStorage.setItem("shippingAddress", JSON.stringify(state.shippingAddress));
    },
    savePaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
      localStorage.setItem("paymentMethod", JSON.stringify(state.paymentMethod));
    },
  },
});

export const {
  addItem,
  increaseQty,
  decreaseQty,
  removeItem,
  clearItems,
  saveShippingAddress,
  savePaymentMethod,
} = cartSlice.actions;